<nav id="sidebar_r" (click)="stopPropagation($event)">
    <div id="dismiss1" (click)="dismissRightSidebar()">
        <i class="fas fa-times"></i>
    </div>

    <div class="sidebar-header heading_1 right_sidebar_heading">
        <span *ngIf="isSalesCode">Save Filters</span>
        <span *ngIf="!isSalesCode">Group</span>
    </div>

    <ul class="p-0 border-bottom m-0 mb-1" *ngIf="isSalesCode">
        <li class="active ">
            <a href="#categorySubMenu" data-toggle="collapse" aria-expanded="false" id="categoryBarMenu">Category<i
                    class="fas fa-chevron-down"></i></a>
            <ul class="collapse list-unstyled" id="categorySubMenu">
                <li>
                    <div class="d-flex pl-2  mb-1 mt-1 filter_dropdown_div" (click)="selectAllFilters()">
                        <div class="mr-2" style="position: relative; width: 20px">
                            <div class="container_chk">
                                <input type="checkbox" [checked]="selectedFiltersFlag">
                                <span class="checkmark"></span>
                            </div>
                        </div>
                        <div style="position: relative">
                            <span class="bodyCopy">Select
                                all</span>
                        </div>
                    </div>
                </li>
                <li *ngFor="let filteree of filterList">
                    <div class="d-flex pl-2  mb-1 mt-1 filter_dropdown_div" (click)="addFilterToList(filteree.value)">
                        <div class="mr-2" style="position: relative; width: 20px">
                            <div class="container_chk">
                                <input type="checkbox" [checked]="filter.filteredList.includes(filteree.value)">
                                <span class="checkmark"></span>
                            </div>
                        </div>
                        <div style="position: relative">
                            <span class="bodyCopy">{{filteree.name}}</span>
                        </div>
                    </div>
                </li>
                <li class="mt-1">
                    <span class="text-danger errorText" *ngIf="validationFlag">* Select atleast one filter</span>
                </li>
            </ul>
        </li>
    </ul>

    <ul class="p-0 border-bottom m-0 mb-1 ">
        <li class="active ">
            <a href="#groupBySubmenu" data-toggle="collapse" aria-expanded="false" id="groupByMenu"
                *ngIf="isSalesCode">Group By<i class="fas fa-chevron-down"></i></a>
            <ul class="collapse list-unstyled" [class.show]="!isSalesCode" id="groupBySubmenu">
                <li class="groupOptions">
                    <div class="groupOptions" (click)="showValue()" style="position:relative">
                        <label class="container_rd groupOptions">
                            <input type="radio" checked value=null name="groupByOptions">
                            <span class="checkmark_rd"></span>
                            <span class="bodyCopy ml-2">None</span>
                        </label>
                    </div>
                </li>
                <li class="groupOptions" *ngFor="let group of groupByList">
                    <div class="groupOptions" style="position:relative">
                        <label class="container_rd groupOptions">
                            <input type="radio" value="{{group.value}}" [(ngModel)]="filter.groupBy"
                                name="groupByOptions">
                            <span class="checkmark_rd"></span>
                            <span class="bodyCopy ml-2">{{group.name}}</span>
                        </label>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
    <ul class="p-0 border-bottom  my-2 " id="activeProjects" *ngIf="isSalesCode">
        <li class="active">
            <ul class="list-unstyled">
                <li>
                    <div class="d-flex pl-2  mb-2 mt-2 filter_dropdown_div" (click)="selectActiveProjects()">
                        <div class="mr-2" style="position: relative; width: 20px">
                            <div class="container_chk">
                                <input type="checkbox" [checked]="filter.activeProjects">
                                <span class="checkmark"></span>
                            </div>
                        </div>
                        <div style="position: relative">
                            <span class="bodyCopy alltokens">Active Projects</span>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
    <ul class="p-0 mb-1" style="margin-bottom:3.5rem!important" id="displayOptions" *ngIf="isSalesCode">
        <li class="active">
            <a>Display Options</a>
            <ul class="list-unstyled" id="">
                <li>
                    <div style="position:relative" class="d-flex justify-content-start pl-2">
                        <i class="fas fa-grip-horizontal" (click)="updateDisplayType('card')"
                            [ngClass]="{modeactive: filter.displayType === 'card'}"></i>
                        <i class="fas fa-th-list" (click)="updateDisplayType('list')"
                            [ngClass]="{modeactive: filter.displayType === 'list'}"></i>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
    <div style="width: inherit;cursor:pointer;position:fixed;bottom: 0;">
        <button type="button" (click)="emitFilters()" [disabled]="filter.filteredList.length==0" style="cursor:pointer"
            class="mt-2 filter-btn">Apply Filters
        </button>
    </div>
</nav>